import { Apple, ExternalLink, PackageCheck, ShieldCheck, Sparkles } from "lucide-react";

export const METERLING_VERSION = "0.2.1-alpha.1";
export const METERLING_RELEASE_REPOSITORY = "https://github.com/alwaysday1/meterling-releases";
const RELEASE_BASE = `${METERLING_RELEASE_REPOSITORY}/releases/download/v${METERLING_VERSION}`;
const DMG_URL = `/api/downloads/meterling/v${METERLING_VERSION}/mac-x64`;

export function DownloadPage() {
  const checksumsUrl = `${RELEASE_BASE}/checksums.txt`;
  return (
    <article className="desktop-download-page">
      <section className="download-hero">
        <div className="download-copy">
          <p className="eyebrow">METERLING · PUBLIC ALPHA</p>
          <h1>把 AI 使用量，养成一只桌面伙伴。</h1>
          <p>Meterling 在本机统计 Codex 与 Claude Code 的有效 Token，用使用量解锁抽奖、收藏物品和淘汰合同。它是 Codex Pet Lab 的独立客户端，不是 OpenAI 官方产品。</p>
          <div className="download-actions">
            <a className="primary-button desktop-download-primary" href={DMG_URL}><Apple size={18} /> 下载 macOS Intel 版</a>
            <a className="secondary-button" href="/play?demo=1&demoTokens=1500000">先玩网页版</a>
          </div>
          <div className="download-meta"><span>v{METERLING_VERSION}</span><span>macOS 12+</span><span>约 120–135 MB</span><span>未签名 Alpha</span></div>
        </div>
        <div className="download-mascot" aria-label="Meterling black cat placeholder"><span>✦</span><b>🐈‍⬛</b><small>INPUT + OUTPUT + CACHE WRITE</small></div>
      </section>

      <section className="download-feature-grid">
        <article><Sparkles /><h2>多工具计量</h2><p>从 Codex 与 Claude Code 本地日志提取 Token 数字，不保存或上传代码和对话内容。</p></article>
        <article><ShieldCheck /><h2>与原生宠物共存</h2><p>独立应用目录和 Bundle ID；可关闭始终置顶，不修改 Codex 原生宠物配置。</p></article>
        <article><PackageCheck /><h2>公开可验证</h2><p>安装包由本站直接分发，GitHub Release 提供版本说明与 SHA-256 校验文件。</p></article>
      </section>

      <section className="download-install">
        <div><p className="eyebrow">INSTALL</p><h2>安装说明</h2><ol><li>下载 DMG，打开后将 Meterling 拖入 Applications。</li><li>首个 Alpha 尚未签名；第一次启动请右键应用并选择“打开”。</li><li>应用每 30 秒刷新本机统计；关闭“始终置顶”可避免和 Codex 原生宠物重叠。</li></ol></div>
        <aside><strong>发布信息</strong><a href={checksumsUrl}>SHA-256 checksum <ExternalLink size={13} /></a><a href={`${METERLING_RELEASE_REPOSITORY}/releases/latest`}>GitHub Release notes <ExternalLink size={13} /></a><small>Apple Silicon、Windows 与 ZIP 构建将在后续 Alpha 增加。</small></aside>
      </section>
    </article>
  );
}
